import { api } from "../api";

export interface OpacIntegrationsConfig {
  opacKeySelfService: boolean;
  publicOpacPath: string;
}

export interface OpacApplication {
  id: string;
  name: string;
  allowedOrigins: string[];
  keyPrefix: string;
  isActive: boolean;
  lastUsedAt?: string | null;
  usageCount: number;
  rotatedAt?: string | null;
  createdAt: string;
  updatedAt: string;
  revokedAt?: string | null;
}

export interface CreateOpacApplicationPayload {
  name: string;
  allowedOrigins?: string[];
}

export async function fetchOpacIntegrationsConfig(): Promise<OpacIntegrationsConfig> {
  const { data } = await api.get<OpacIntegrationsConfig>("/opac-applications/config");
  return data;
}

export async function fetchOpacApplications(): Promise<OpacApplication[]> {
  const { data } = await api.get<OpacApplication[]>("/opac-applications");
  return data;
}

export async function createOpacApplication(
  payload: CreateOpacApplicationPayload
): Promise<{ application: OpacApplication; apiKey: string }> {
  const { data } = await api.post<{ application: OpacApplication; apiKey: string }>(
    "/opac-applications",
    payload
  );
  return data;
}

export async function rotateOpacApplication(id: string): Promise<{ id: string; apiKey: string }> {
  const { data } = await api.post<{ id: string; apiKey: string }>(
    `/opac-applications/${id}/rotate`
  );
  return data;
}

export async function revokeOpacApplication(id: string): Promise<void> {
  await api.delete(`/opac-applications/${id}`);
}

export async function updateOpacIntegrationsConfigSuperAdmin(
  tenantId: string,
  opacKeySelfService: boolean
): Promise<void> {
  await api.patch(`/super-admin/tenants/${tenantId}/opac-integrations-config`, {
    opacKeySelfService,
  });
}

export async function fetchOpacApplicationsSuperAdmin(
  tenantId: string
): Promise<OpacApplication[]> {
  const { data } = await api.get<OpacApplication[]>(
    `/super-admin/tenants/${tenantId}/opac-applications`
  );
  return data;
}

export async function createOpacApplicationSuperAdmin(
  tenantId: string,
  payload: CreateOpacApplicationPayload
): Promise<{ application: OpacApplication; apiKey: string }> {
  const { data } = await api.post<{ application: OpacApplication; apiKey: string }>(
    `/super-admin/tenants/${tenantId}/opac-applications`,
    payload
  );
  return data;
}

export async function revokeOpacApplicationSuperAdmin(tenantId: string, id: string): Promise<void> {
  await api.delete(`/super-admin/tenants/${tenantId}/opac-applications/${id}`);
}

export async function rotateOpacApplicationSuperAdmin(
  tenantId: string,
  id: string
): Promise<{ id: string; apiKey: string }> {
  const { data } = await api.post<{ id: string; apiKey: string }>(
    `/super-admin/tenants/${tenantId}/opac-applications/${id}/rotate`
  );
  return data;
}
